import React, { useState, useEffect } from "react";
import { Box, Grid, Button } from "@mui/material"; // Import MUI components
import { useDispatch } from "react-redux";
import { fetchArticles } from "../../store/articleSlice"; // Import your Redux action
import FilterInput from "./FilterInput";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Using ExpandMore icon

const ArticleFilter = () => {
  const [filters, setFilters] = useState({ code: "", name: "" });
  const [isFilterVisible, setIsFilterVisible] = useState(false); // State for toggling filter visibility
  const dispatch = useDispatch();

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };

  useEffect(() => {
    dispatch(fetchArticles(filters)); // Fetch articles whenever filters change
  }, [filters, dispatch]);

  const handleToggleVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

 
  return (
    <Box>
        {/* Stylish Toggle Button */}
      <Button
        variant="outlined"
        color="primary"
        endIcon={<ExpandMoreIcon />}
        onClick={handleToggleVisibility}
        sx={{ marginBottom: 2 }}
      >
        {isFilterVisible ? "Hide Filters" : "Show Filters"}
      </Button>
    
      {isFilterVisible && (
        <Grid container spacing={2} marginTop={2}>
          <Grid item xs={6} sm={4}>
            <FilterInput
              label="Code"
              filterKey="code"
              filterValue={filters.code}
              onFilterChange={handleFilterChange}
              debounceTime={500} // Debounce duration
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <FilterInput
              label="Name"
              filterKey="name"
              filterValue={filters.name}
              onFilterChange={handleFilterChange}
              debounceTime={500} // Debounce duration
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <FilterInput
              label="Prix de vente"
              filterKey="price_v"
              filterValue={filters.price_v}
              onFilterChange={handleFilterChange}
              debounceTime={500} // Debounce duration
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <FilterInput
              label="Prix de Revient"
              filterKey="price_r"
              filterValue={filters.price_r}
              onFilterChange={handleFilterChange}
              debounceTime={500} // Debounce duration
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ArticleFilter;
